import { useQuery } from "react-query";
import { mutateErrors } from "../../../utils";
import { useServiceProviderId } from "../../service-provider/hooks/useServiceProviderId";
import { parseServicesByProviderToFrontEndModel } from "../helpers/parseServicesToFrontEndModel";
import { useServicesConfig } from "../modals/hooks/useServicesConfig";
import useServicesQueries from "./useServicesQueries";
import { QUERY_KEYS } from "../../../constants";

export const useServicesPage = () => {
  const serviceWizardConfigs = useServicesConfig();
  const { getServicesList } = useServicesQueries();
  const serviceProviderId = useServiceProviderId();
  const { servicesListByProvider } = QUERY_KEYS;

  const { isLoading, isError, error, data, refetch } = useQuery(
    [servicesListByProvider, serviceProviderId],
    async () => {
      const response = await getServicesList({ serviceProviderId });
      return parseServicesByProviderToFrontEndModel(response.data);
    },
  );

  let errorMessage;
  if (isError) {
    const { message } = mutateErrors(error);
    errorMessage = message;
  }

  return {
    isError,
    services: data,
    isLoading,
    errorMessage,
    servicesWizardConfigs: serviceWizardConfigs,
    refetchServices: refetch,
  };
};
